export default __webpack_public_path__ + "media/karbon-logo.b1067.png";